/**
 * Application-wide configuration settings
 * Centralized to make it easier to manage and update
 */

export const appConfig = {
  /**
   * Company information
   */
  company: {
    name: 'Sully.ai',
    website: 'https://sully.ai',
    supportEmail: 'support@sully.ai',
    salesEmail: 'sales@sully.ai',
  },

  /**
   * Feature flags and settings
   */
  features: {
    /**
     * Organization account settings
     */
    organization: {
      /**
       * Default subject line for sales contact regarding account activation
       */
      activationEmailSubject: 'Organization Account Activation Request',
    },
  },

  /**
   * UI text and messages
   */
  ui: {
    /**
     * Messages related to account access
     */
    accountAccess: {
      pendingTitle: 'Account Pending Approval',
      pendingDescription:
        'Your organization account is pending approval before you can access the full features.',
      whatHappensNext:
        'Our team reviews all organizations to ensure they meet our requirements. This process typically takes 1-2 business days.',
      needAccessSooner:
        'Need access sooner? Contact our sales team to expedite the approval process.',
      thankYouMessage:
        'Thank you for contacting us! Our team will reach out to you shortly.',
    },
  },
}
